import { render, staticRenderFns } from "./TextfieldAnswer.vue?vue&type=template&id=7b9eff3c&scoped=true"
import script from "./TextfieldAnswer.vue?vue&type=script&lang=js"
export * from "./TextfieldAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9eff3c",
  null
  
)

export default component.exports